import React from 'react';

/*
  PrimaryButton component
  - Keeps existing visual styles by using the same CSS classes: 'btn', 'btn-primary', and optional 'btn-large'.
  - Accepts standard button props and forwards them to the native element.
*/

const PrimaryButton = ({
  children,
  onClick,
  type = 'button',
  size = 'normal', // 'normal' | 'large'
  className = '',
  disabled = false,
  ...rest
}) => {
  const sizeClass = size === 'large' ? 'btn-large' : '';
  const classes = `btn btn-primary ${sizeClass} ${className}`.trim();

  return (
    <button type={type} className={classes} onClick={onClick} disabled={disabled} {...rest}>
      {children}
    </button>
  );
};

export default PrimaryButton;


